import BreadCrumb from "components/Common/BreadCrumb";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Card,
    Col,
    Container,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
} from "reactstrap";
import { useQueryParams } from "use-query-params";
import TabArticle from "./Article";
import TabLog from "./Log";
import TabTossData from "./TossData";

const NewsTossStock = () => {
    const { t, i18n } = useTranslation();

    const [activeTab, setActiveTab] = useState("TOSS_DATA");

    const [query, setQuery]: any = useQueryParams({});

    const tabChange = (tab: any) => {
        if (activeTab !== tab) {
            setQuery({}, "push");
            setActiveTab((_prev) => tab);
        }
    };

    useEffect(() => {
        document.title = `${t('News Stock')} - ${t('Boosting Content')} | PRESS Ai`;
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("News Toss Stock")} pageTitle={t("Boosting Content")} />
                    <Row>
                        <Col lg={12}>
                            <Card
                                id="ARTICLE"
                                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
                            >
                                <div
                                    style={{
                                        background: "#f3f6f9",
                                        borderTopLeftRadius: "0.6rem",
                                        borderTopRightRadius: "0.6rem",
                                    }}
                                >
                                    <div
                                        className="d-block"
                                        style={{
                                            background: "#f3f6f9",
                                            borderRadius: "0.6rem",
                                            width: "fit-content",
                                        }}
                                    >
                                        <Nav tabs className="nav nav-tabs nav-link-none-hover nav-justified">
                                            <NavItem style={{ minWidth: '110px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "TOSS_DATA" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "TOSS_DATA" ? "white" : "unset"}`,
                                                        borderTopRightRadius: 0
                                                    }}
                                                    onClick={() => tabChange("TOSS_DATA")}
                                                >
                                                    {t("Toss Data")}
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={{ minWidth: '110px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "ARTICLE" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "ARTICLE" ? "white" : "unset"}`,
                                                        borderTopLeftRadius: 0,
                                                        borderTopRightRadius: 0,
                                                    }}
                                                    onClick={() => tabChange("ARTICLE")}
                                                >
                                                    {t("Article")}
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={{ minWidth: '110px' }}>
                                                <NavLink
                                                    style={{
                                                        cursor: "pointer",
                                                        background: `${activeTab === "LOG" ? "var(--vz-primary)" : "unset"}`,
                                                        color: `${activeTab === "LOG" ? "white" : "unset"}`,
                                                        borderTopLeftRadius: 0,
                                                        borderTopRightRadius: 0,
                                                    }}
                                                    onClick={() => tabChange("LOG")}
                                                >
                                                    {t("Log")}
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </div>
                                </div>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="TOSS_DATA">
                                        {activeTab === "TOSS_DATA" && (<TabTossData />)}
                                    </TabPane>
                                    <TabPane tabId="ARTICLE">
                                        {activeTab === "ARTICLE" && (<TabArticle />)}
                                    </TabPane>
                                    <TabPane tabId="LOG">
                                        {activeTab === "LOG" && (<TabLog />)}
                                    </TabPane>
                                </TabContent>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default NewsTossStock;
